import Form from 'cerebral-module-forms/Form'

/**
 * Prepare fields for login.
*/
export default function prepareLoginFields({ state }) {
  let path = 'client.registrating.current.login'
  state.set(
    path,
    Form({
      username: {
        value: '',
        isRequired: true,
        client: true,
        dependsOn: `${path}.password`
      },
      password: {
        value: '',
        isRequired: true,
        client: true,
        type: 'password',
        dependsOn: `${path}.username`
      }
    })
  )
}



// WEBPACK FOOTER //
// ./src/modules/app/actions/prepareLoginFields.js